import { render, staticRenderFns } from "./TypoMVVConfig.vue?vue&type=template&id=55844e54&scoped=true&"
import script from "./TypoMVVConfig.vue?vue&type=script&lang=js&"
export * from "./TypoMVVConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55844e54",
  null
  
)

export default component.exports